import React, { useEffect } from "react";
import { X } from "lucide-react";
import { cn } from "@/lib/utils";

export function Modal({ open, onClose, children, className, testid }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[100] flex items-end justify-center sm:items-center" data-testid={testid}>
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm animate-fade-up" onClick={onClose} style={{ animationDuration: "0.2s" }} />
      <div
        className={cn(
          "relative z-10 w-full max-w-lg overflow-hidden rounded-t-3xl border border-am-border bg-am-surface shadow-2xl sm:rounded-3xl animate-fade-up",
          className
        )}
        style={{ animationDuration: "0.3s" }}
      >
        <button onClick={onClose} data-testid="modal-close" className="absolute right-4 top-4 z-20 grid h-8 w-8 place-items-center rounded-full bg-white/10 text-white transition-colors hover:bg-white/20">
          <X className="h-4 w-4" />
        </button>
        {children}
      </div>
    </div>
  );
}
